<div class="display-grid-cards">
  <ng-container *ngIf="noUsersFound()">
    <p><T str="No users found"></T></p>
  </ng-container>

  <ng-container *ngFor="let user of projectInvolvedService.viewUsers()">
    <apex-project-involved-card [extendedUser]="user"></apex-project-involved-card>
  </ng-container>
</div>
